export const itemsCategoryColumns = [
    {
      Header: 'Items Id',
      accessor: 'itemsId',
    },
    {
      Header: 'Category Name',
      accessor: 'categoryName',
    },
    {
        Header: 'Status',
        accessor: 'status',
    },
    {
      Header: 'Actions',
      accessor: 'actions',
    }
  ];

export const itemsCategoryTableData = [
    {   
        itemsId:'1101',
        categoryName:'House Keeping',
        status: 'Active',
    },
    {   
        itemsId:'1102',
        categoryName:'Food Items',
        status: 'Active',
    },
    {   
        itemsId:'1103',
        categoryName:'Facility',
        status: 'Active',
    },
    {   
      itemsId:'1104',
      categoryName:'Personal Care Items',
      status: 'Active',
    },
    {   
      itemsId:'1105',
      categoryName:'Miscellaneous',
      status: 'Active',
    },
    {   
      itemsId:'1106',
      categoryName:'Building Materials',
      status: 'Active',
    },
    {   
      itemsId:'1107',
      categoryName:'Food Store', 
      status: 'Active',
    },
]